import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { ACCIDENTAL_ACTION_DEBOUNCE_TIME_SHORT } from "app/pages/sales-intelligence/constants/timeouts";

export const StyledHistoryDDContainer = styled.div`
    position: absolute;
    top: 0;
    left: 44px;
    width: 264px;
    padding: 12px 8px;
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 8px;
    box-sizing: border-box;
`;

export const StyledHistoryDDItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 20px;
    max-height: 452px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${colorsPalettes.carbon[200]};
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: ${colorsPalettes.carbon[0]};
    }
`;

export const StyledHistoryDDItemInner = styled.div`
    max-height: 18px;
    overflow: hidden;
    transition: max-height 450ms ease-in-out;
    transition-delay: ${ACCIDENTAL_ACTION_DEBOUNCE_TIME_SHORT}ms;
`;

export const StyledHistoryDDItem = styled.div<{ isActive?: boolean }>`
    padding: 16px;
    ${setFontVariant("input2", colorsPalettes.carbon[400])};
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-color: ${({ isActive }) => (isActive ? colorsPalettes.blue[350] : colorsPalettes.carbon[50])};
    cursor: pointer;
    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
        ${StyledHistoryDDItemInner} {
            max-height: 40px;
        }
    }
`;

export const StyledHistoryDDItemTitle = styled.div`
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const StyledEmptyState = styled.div`
    padding: 44px 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const StyledEmptyStateIcon = styled(SWReactIcons)`
    width: 155px;
    margin-bottom: 16px;
`;
